/**
 * Board sizes per difficulty - must stay in sync with the generators' getSize()
 *
 * The labels name the size, because size is the only thing that actually
 * differs: every generator in GameGenerator.js overrides getSize() and nothing
 * else, so "Easy" and "Hard" were promising a difficulty knob that does not
 * exist. Extreme keeps its name - it reads as off the end of the scale rather
 * than as a rating, and the board earns it at 15x10.
 *
 * `name` is the stored key: it is in component state, in the Statistics filter,
 * and in the mapping back from a replayed board. Renaming those would be a data
 * change rather than a wording one, so only `label` moves.
 */
const DIFFICULTIES = [
  { name: 'Easy', label: '🍰 Mini', rows: 5, cols: 5 },
  { name: 'Medium', label: '🎯 Classic', rows: 7, cols: 7 },
  { name: 'Hard', label: '🦑 Huge', rows: 10, cols: 10 },
  { name: 'Extreme', label: '🔥 Extreme', rows: 15, cols: 10 },
];

/**
 * Find the difficulty a board belongs to, by its dimensions
 * @param {number[][]} numbers
 * @returns {{name: string, label: string, rows: number, cols: number} | undefined}
 */
function difficultyOf(numbers) {
  return DIFFICULTIES.find(
    ({ rows, cols }) => rows === numbers.length && cols === numbers[0].length
  );
}

export { DIFFICULTIES, difficultyOf };
